<template>
	<div class="pui-form">
		<libramiento-termc-modals :modelName="modelName"></libramiento-termc-modals>
		<pui-form-header :showHeader="!isCreatingElement" v-if="modelLoaded">
			<libramientotermcformheader></libramientotermcformheader>
		</pui-form-header>
		<v-form class="pui-libramientotermcform mb-4 pb-4" ref="form" v-model="valid" lazy-validation @submit.prevent v-if="modelLoaded">
			<v-tabs v-model="tabmodel" class="ml-4 mb-3">
				<v-tab :key="0" :href="'#maintab'">{{ $t('libramientotermc.maintab') }}</v-tab>
				<v-tab :key="1" :href="'#historicolibtermc'" v-if="!isCreatingElement">{{ $t('libramientotermc.historico') }}</v-tab>
			</v-tabs>
			<v-tabs-items v-model="tabmodel" class="ml-4 mb-3">
				<v-tab-item :key="0" :value="`maintab`">
					<libramiento-form-base
						:model="model"
						:formDisabled="formDisabled"
						:modelLoaded="modelLoaded"
						tipoLibramiento="TC"
						:conductorFixedFilter="fixedFilterConductor"
					></libramiento-form-base>
				</v-tab-item>
				<v-tab-item :key="1" :value="`historicolibtermc`" lazy v-if="!isCreatingElement">
					<pui-master-detail
						componentName="historicolibtermcgrid"
						:parentModelName="modelName"
						:parentPk="pk"
						:parentPkChildFk="{ idlibramiento: 'idlibramiento' }"
					></pui-master-detail>
				</v-tab-item>
			</v-tabs-items>
			<pui-form-footer>
				<v-layout>
					<v-flex xs12 sm12 md8 lg8 xl8>
						<v-layout>
							<v-flex xs12 md4>
								<!--<pui-form-mini-audit class="pl-2" :model="model" v-if="this.method !== 'create'"></pui-form-mini-audit>-->
							</v-flex>
							<v-flex xs12 md8>
								<v-layout justify-end fill-height>
									<v-btn v-if="!formDisabled" depressed color="secondary" class="elevation-0" @click.native="save(false)">
										{{ this.$t('form.save') }}
									</v-btn>
									<v-btn text outlined @click.native="back()">{{ $t('form.cancel') }}</v-btn>
								</v-layout>
							</v-flex>
						</v-layout>
					</v-flex>
				</v-layout>
			</pui-form-footer>
		</v-form>
		<pui-form-loading v-else></pui-form-loading>
	</div>
</template>

<script>
import PuiFormMethodsMixin from 'pui9-mixins/PuiFormMethodsMixin';

import LibramientoFormBase from '../LibramientoFormBase';
import LibramientoTermcActions from './LibramientoTermcActions';
import LibramientoTermcModals from './LibramientoTermcModals';

export default {
	name: 'libramientotermcform',
	mixins: [PuiFormMethodsMixin],
	components: { LibramientoFormBase, LibramientoTermcModals },
	data() {
		return {
			modelName: 'libramientotermc',
			actions: LibramientoTermcActions.formactions,
			parentModelPk: null,
			tabmodel: 'maintab',
			fixedFilterConductor: null
		};
	},
	methods: {
		// Override
		afterGetData() {
			this.parentModelPk = { idencargo: this.model.idencargo };
		}
	},
	mounted() {
		this.$puiEvents.$on(`refreshForm-action-running-ended-${this.modelName}`, () => {
			//Para hacer recarga de la pantalla del form al realizar una accion
			this.modelLoaded = false;
			this.onReady();
		});
	},
	destroyed() {
		this.$puiEvents.$off(`refreshForm-action-running-ended-${this.modelName}`);
	}
};
</script>

<style scoped></style>

<i18n>
{
    "en": {
		"libramientotermc.maintab": "Riddance",
		"libramientotermc.consultasrealizadas": "Inquiry performed",
		"libramientotermc.loterecibido": "Lots received",
		"libramientotermc.historico": "Historic"
    },
    "es": {
        "libramientotermc.maintab": "Libramiento",
		"libramientotermc.consultasrealizadas": "Consultas realizadas",
		"libramientotermc.loterecibido": "Lotes recibidos",
		"libramientotermc.historico": "Histórico"
    },
    "ca": {
        "libramientotermc.maintab": "Lliurament",
		"libramientotermc.consultasrealizadas": "Consultes realitzades",
		"libramientotermc.loterecibido": "Lots rebuts",
		"libramientotermc.historico": "Històric"
    }
}
</i18n>
